"use client"

import { useEffect } from "react"

export function ThemeToggle() {
  useEffect(() => {
    const syncDarkMode = () => {
      const isDarkMode = document.body.classList.contains("dark-portal")
      document.documentElement.classList.toggle("dark", isDarkMode)
    }

    syncDarkMode()

    const observer = new MutationObserver(syncDarkMode)
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    })

    return () => observer.disconnect()
  }, [])

  return null
}